import { useEffect, useRef } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import type { TreeObjectItems } from '@confluence/tree';

import type { ContentTreeItem } from './data-transformers';
import { oneOnOnePagesDetectedEvent } from './analytics';

/**
 * Custom hook to track analytics when 4 or more pages have "1:1" in their title
 * @param pages - The current pages from the page tree state
 * @param space - The current space information
 */
export const useOneOnOnePagesAnalytics = (
	pages?: TreeObjectItems<ContentTreeItem>,
	space?: { id: string } | null,
) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const hasTrackedRef = useRef(false);

	useEffect(() => {
		if (!pages || Object.keys(pages).length === 0) {
			return;
		}

		const oneOnOnePages = Object.values(pages).filter(
			(page) =>
				page.data?.title?.toLowerCase().includes('1:1') ||
				page.data?.fullTitle?.toLowerCase().includes('1:1'),
		);

		// Only track once when we first detect 4 or more 1:1 pages
		if (oneOnOnePages.length >= 4 && !hasTrackedRef.current) {
			createAnalyticsEvent(
				oneOnOnePagesDetectedEvent(oneOnOnePages.length, Object.keys(pages).length, space?.id),
			).fire();
			hasTrackedRef.current = true;
		}
	}, [pages, createAnalyticsEvent, space?.id]);
};
